import React, { useContext, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import ForecastSpread from './ForecastSpread';
import { ColorContext } from 'App';

export default function DropDownSpread({
  style,
  title,
  data,
  content,
  dataIcons,
  buttonClassName,
  titleClassName,
  titleStyle,
  chevronSize,
}) {
  const [opened, setOpened] = useState(false);

  const theme = useContext(ColorContext);
  return (
    <button
      className={buttonClassName ?? 'd-flex flex-column bg-primary w-100 mt-2 p-3 rounded-2'}
      style={{
        ...style,
      }}
      onClick={() => setOpened(!opened)}
    >
      {/* Closed */}
      {!opened && (
        <div className="d-flex flex-row w-100 justify-content-between align-items-center">
          <div
            className={titleClassName ?? 'fs-5 fw-bold justify-content-start'}
            style={titleStyle}
          >
            {title}
          </div>
          <FaChevronDown size={chevronSize} />
        </div>
      )}

      {/* Opened */}
      {opened && !content && (
        <ForecastSpread
          style={{ width: '100%' }}
          header={title}
          data={data}
          dataIcons={dataIcons}
        />
      )}

      {opened && content && <div className="w-100">{content}</div>}
    </button>
  );
}
